import React from 'react';

const UsFlag: React.FC<{}> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="84" height="56" viewBox="0 0 84 56" fill="none">
    <g clipPath="url(#clip0_47_1692)">
      <path d="M0 0H106.4V56H0V0Z" fill="#B22234" />
      <path
        d="M0 6.46149H106.4H0ZM106.4 15.0769H0H106.4ZM0 23.6923H106.4H0ZM106.4 32.3076H0H106.4ZM0 40.923H106.4H0ZM106.4 49.5384H0H106.4Z"
        fill="black"
      />
      <path
        d="M0 6.46149H106.4M106.4 15.0769H0M0 23.6923H106.4M106.4 32.3076H0M0 40.923H106.4M106.4 49.5384H0"
        stroke="white"
        strokeWidth="4.30769"
      />
      <path d="M0 0H42.56V30.1538H0V0Z" fill="#3C3B6E" />
      <path
        d="M3.54669 1.29227L4.55949 4.40934L1.90796 2.48288H5.18544L2.5339 4.40934L3.54669 1.29227Z"
        fill="white"
      />
      <path
        d="M3.54669 7.32297L4.55949 10.44L1.90796 8.51358H5.18544L2.5339 10.44L3.54669 7.32297Z"
        fill="white"
      />
      <path
        d="M3.54669 13.3537L4.55949 16.4708L1.90796 14.5443H5.18544L2.5339 16.4708L3.54669 13.3537Z"
        fill="white"
      />
      <path
        d="M3.54669 19.3845L4.55949 22.5016L1.90796 20.5751H5.18544L2.5339 22.5016L3.54669 19.3845Z"
        fill="white"
      />
      <path
        d="M3.54669 25.4153L4.55949 28.5323L1.90796 26.6059H5.18544L2.5339 28.5323L3.54669 25.4153Z"
        fill="white"
      />
      <path
        d="M7.09332 4.30756L8.10612 7.42463L5.45459 5.49817H8.73207L6.08053 7.42463L7.09332 4.30756Z"
        fill="white"
      />
      <path
        d="M7.09332 10.3382L8.10612 13.4552L5.45459 11.5288H8.73207L6.08053 13.4552L7.09332 10.3382Z"
        fill="white"
      />
      <path
        d="M7.09332 16.369L8.10612 19.486L5.45459 17.5596H8.73207L6.08053 19.486L7.09332 16.369Z"
        fill="white"
      />
      <path
        d="M7.09332 22.3997L8.10612 25.5168L5.45459 23.5903H8.73207L6.08053 25.5168L7.09332 22.3997Z"
        fill="white"
      />
      <path
        d="M10.64 1.29218L11.6527 4.40925L9.00122 2.48279H12.2787L9.62716 4.40925L10.64 1.29218Z"
        fill="white"
      />
      <path
        d="M10.64 7.32288L11.6527 10.44L9.00122 8.51349H12.2787L9.62716 10.44L10.64 7.32288Z"
        fill="white"
      />
      <path
        d="M10.64 13.3537L11.6527 16.4707L9.00122 14.5443H12.2787L9.62716 16.4707L10.64 13.3537Z"
        fill="white"
      />
      <path
        d="M10.64 19.3844L11.6527 22.5015L9.00122 20.575H12.2787L9.62716 22.5015L10.64 19.3844Z"
        fill="white"
      />
      <path
        d="M10.64 25.4152L11.6527 28.5322L9.00122 26.6058H12.2787L9.62716 28.5322L10.64 25.4152Z"
        fill="white"
      />
      <path
        d="M14.1866 4.30746L15.1994 7.42454L12.5479 5.49808H15.8253L13.1738 7.42454L14.1866 4.30746Z"
        fill="white"
      />
      <path
        d="M14.1866 10.3381L15.1994 13.4552L12.5479 11.5287H15.8253L13.1738 13.4552L14.1866 10.3381Z"
        fill="white"
      />
      <path
        d="M14.1866 16.3689L15.1994 19.4859L12.5479 17.5595H15.8253L13.1738 19.4859L14.1866 16.3689Z"
        fill="white"
      />
      <path
        d="M14.1866 22.3997L15.1994 25.5167L12.5479 23.5903H15.8253L13.1738 25.5167L14.1866 22.3997Z"
        fill="white"
      />
      <path
        d="M17.7332 1.29218L18.746 4.40925L16.0945 2.48279H19.372L16.7204 4.40925L17.7332 1.29218Z"
        fill="white"
      />
      <path
        d="M17.7332 7.32288L18.746 10.44L16.0945 8.51349H19.372L16.7204 10.44L17.7332 7.32288Z"
        fill="white"
      />
      <path
        d="M17.7332 13.3537L18.746 16.4707L16.0945 14.5443H19.372L16.7204 16.4707L17.7332 13.3537Z"
        fill="white"
      />
      <path
        d="M17.7332 19.3844L18.746 22.5015L16.0945 20.575H19.372L16.7204 22.5015L17.7332 19.3844Z"
        fill="white"
      />
      <path
        d="M17.7332 25.4152L18.746 28.5322L16.0945 26.6058H19.372L16.7204 28.5322L17.7332 25.4152Z"
        fill="white"
      />
      <path
        d="M21.2798 4.30746L22.2926 7.42454L19.6411 5.49808H22.9186L20.267 7.42454L21.2798 4.30746Z"
        fill="white"
      />
      <path
        d="M21.2798 10.3381L22.2926 13.4552L19.6411 11.5287H22.9186L20.267 13.4552L21.2798 10.3381Z"
        fill="white"
      />
      <path
        d="M21.2798 16.3689L22.2926 19.4859L19.6411 17.5595H22.9186L20.267 19.4859L21.2798 16.3689Z"
        fill="white"
      />
      <path
        d="M21.2798 22.3997L22.2926 25.5167L19.6411 23.5903H22.9186L20.267 25.5167L21.2798 22.3997Z"
        fill="white"
      />
      <path
        d="M24.8265 1.29211L25.8393 4.40919L23.1877 2.48273H26.4652L23.8137 4.40919L24.8265 1.29211Z"
        fill="white"
      />
      <path
        d="M24.8265 7.32281L25.8393 10.4399L23.1877 8.51343H26.4652L23.8137 10.4399L24.8265 7.32281Z"
        fill="white"
      />
      <path
        d="M24.8265 13.3536L25.8393 16.4707L23.1877 14.5442H26.4652L23.8137 16.4707L24.8265 13.3536Z"
        fill="white"
      />
      <path
        d="M24.8265 19.3844L25.8393 22.5014L23.1877 20.575H26.4652L23.8137 22.5014L24.8265 19.3844Z"
        fill="white"
      />
      <path
        d="M24.8265 25.4151L25.8393 28.5322L23.1877 26.6057H26.4652L23.8137 28.5322L24.8265 25.4151Z"
        fill="white"
      />
      <path
        d="M28.3731 4.3074L29.3859 7.42448L26.7344 5.49802H30.0119L27.3603 7.42448L28.3731 4.3074Z"
        fill="white"
      />
      <path
        d="M28.3731 10.338L29.3859 13.4551L26.7344 11.5286H30.0119L27.3603 13.4551L28.3731 10.338Z"
        fill="white"
      />
      <path
        d="M28.3731 16.3688L29.3859 19.4859L26.7344 17.5594H30.0119L27.3603 19.4859L28.3731 16.3688Z"
        fill="white"
      />
      <path
        d="M28.3731 22.3996L29.3859 25.5166L26.7344 23.5902H30.0119L27.3603 25.5166L28.3731 22.3996Z"
        fill="white"
      />
      <path
        d="M31.92 1.29218L32.9328 4.40925L30.2812 2.48279H33.5587L30.9072 4.40925L31.92 1.29218Z"
        fill="white"
      />
      <path
        d="M31.92 7.32288L32.9328 10.44L30.2812 8.51349H33.5587L30.9072 10.44L31.92 7.32288Z"
        fill="white"
      />
      <path
        d="M31.92 13.3537L32.9328 16.4707L30.2812 14.5443H33.5587L30.9072 16.4707L31.92 13.3537Z"
        fill="white"
      />
      <path
        d="M31.92 19.3844L32.9328 22.5015L30.2812 20.575H33.5587L30.9072 22.5015L31.92 19.3844Z"
        fill="white"
      />
      <path
        d="M31.92 25.4152L32.9328 28.5322L30.2812 26.6058H33.5587L30.9072 28.5322L31.92 25.4152Z"
        fill="white"
      />
      <path
        d="M35.4666 4.30746L36.4794 7.42454L33.8279 5.49808H37.1054L34.4538 7.42454L35.4666 4.30746Z"
        fill="white"
      />
      <path
        d="M35.4666 10.3381L36.4794 13.4552L33.8279 11.5287H37.1054L34.4538 13.4552L35.4666 10.3381Z"
        fill="white"
      />
      <path
        d="M35.4666 16.3689L36.4794 19.4859L33.8279 17.5595H37.1054L34.4538 19.4859L35.4666 16.3689Z"
        fill="white"
      />
      <path
        d="M35.4666 22.3997L36.4794 25.5167L33.8279 23.5903H37.1054L34.4538 25.5167L35.4666 22.3997Z"
        fill="white"
      />
      <path
        d="M39.0135 1.29218L40.0263 4.40925L37.3748 2.48279H40.6522L38.0007 4.40925L39.0135 1.29218Z"
        fill="white"
      />
      <path
        d="M39.0135 7.32288L40.0263 10.44L37.3748 8.51349H40.6522L38.0007 10.44L39.0135 7.32288Z"
        fill="white"
      />
      <path
        d="M39.0135 13.3537L40.0263 16.4707L37.3748 14.5443H40.6522L38.0007 16.4707L39.0135 13.3537Z"
        fill="white"
      />
      <path
        d="M39.0135 19.3844L40.0263 22.5015L37.3748 20.575H40.6522L38.0007 22.5015L39.0135 19.3844Z"
        fill="white"
      />
      <path
        d="M39.0135 25.4152L40.0263 28.5322L37.3748 26.6058H40.6522L38.0007 28.5322L39.0135 25.4152Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_47_1692">
        <rect width="106.4" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default UsFlag;
